const SESSION_KEY = 'raithu_auth_session';
const TTL_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds

interface SessionData {
    username: string;
    expiry: number;
}

export const authClient = {
    saveSession(username: string) {
        const session: SessionData = {
            username,
            expiry: Date.now() + TTL_MS,
        };
        localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    },

    getSession(): SessionData | null {
        const data = localStorage.getItem(SESSION_KEY);
        if (!data) return null;

        try {
            const session: SessionData = JSON.parse(data);
            if (Date.now() > session.expiry) {
                this.clearSession();
                return null;
            }
            return session;
        } catch (e) {
            this.clearSession();
            return null;
        }
    },

    clearSession() {
        localStorage.removeItem(SESSION_KEY);
    },

    isAuthenticated(): boolean {
        return !!this.getSession();
    },
};
